<template>
  <li :class="dropdownContainerClass">
    <a
      :class="`nav-link dropdown-toggle ${dropdownClass} ${textClass}`"
      :id="computedId"
      role="button"
      aria-expanded="false"
      tabindex="0"
      @keypress.enter="$emit('toggleDropdownMenu')"
      @click="$emit('toggleDropdownMenu')"
    >{{ displayedTitle }}</a>
  </li>
</template>


<script>
export default {
  name: "ApplicationMenuDropdown",
  data() {
    return { showDropdownMenu: false };
  },
  props: {
    name: { type: String, default: "" },
    title: { type: String, default: "" },
    textClass: { type: String, default: "" },
    linkTheme: { type: String, default: "" },
    children: {
      type: Array,
      default: function() {
        return [];
      }
    },
    childrenMenuTheme: {
      type: Object,
      default: function() {
        return {
          background: "",
          text: ""
        };
      }
    },
    focused: { type: Boolean, default: false }
  },
  computed: {
    dropdownLinkTheme() {
      return `${
        this.active ? "active router-link-active " : ""
      }nav-link nav-link${
        this.linkTheme.length
          ? "-" + this.linkTheme
          : this.textClass.length
          ? "-" + this.textClass
          : ""
      }`;
    },
    dropdownClass() {
      return `${this.dropdownLinkTheme} ${
        this.focused
          ? this.prefixStringKey(this.childrenMenuTheme, "text", {
              prefix: "text-",
              defaut: ""
            })
          : ""
      }`;
    },
    dropdownContainerClass() {
      return this.focused
        ? `${this.prefixStringKey(this.childrenMenuTheme, "background", {
            prefix: "nav-item bg-",
            defaut: "nav-item"
          })}`
        : "nav-item";
    },
    computedId() {
      return `navbarDropdown${this.name.length ? this.name : this.title}`;
    },
    displayedTitle() {
      return this.title.length ? this.title : this.name;
    },
    childrenNames() {
      let childrenNames = [];
      this.children.forEach(children => {
        if (children.name) childrenNames.push(children.name);
        if (children.children)
          children.children.forEach(child => {
            childrenNames.push(child.name);
          });
      });
      return childrenNames;
    },
    active() {
      return this.childrenNames.includes(this.$route.name);
    }
  },
  methods: {
    getSubpageContainerClass(subpage) {
      return this.getKey(subpage, "containerClass", "col-md-12");
    }
  }
};
</script>